/**
 * Utility to get tables properly formatted
 */
export class DataTableFiller {

  /**
   * Number of rows display for workflow list
   */
  public static NUMBER_OF_ROWS_FOR_WORKFLOW_LIST = 10;

  /**
   * Number of rows display for fold workflow list
   */
  public static NUMBER_OF_ROWS_FOR_WORKFLOW_FOLDS_LIST = 10;

  /**
   * Number of rows display for search result list
   */
  public static NUMBER_OF_ROWS_FOR_SEARCH_RESULT_FOLDS = 10;

  /**
   * Fill any array with the wished number of rows using one element of the row
   *
   * @param {any[]} array - array to fill
   * @param {number} numberOfRows - number of wished rows
   * @param {string} oneParamName - name of the param (column field)
   */
  public static fillAnyArray(array: any[], numberOfRows: number, oneParamName: string): void {
    const numberOfRowsToAdd = Math.ceil(array.length / numberOfRows) * numberOfRows - array.length;
    for (let i = 0; i < numberOfRowsToAdd; i++) {
      const toAdd = {notSelectable: true};
      toAdd[oneParamName] = String.fromCharCode(160);
      array.push(toAdd);
    }

  }

  /**
   *
   * @param {number} numberOfRows - number of wished rows
   * @param {string} oneParamName - name of the param (column field)
   * @return {Array} - the array filled of empty rows
   */
  public static getEmptyArray(numberOfRows: number, oneParamName: string) {

    const array = [];

    for (let i = 0; i < numberOfRows; i++) {
      const toAdd = {notSelectable: true};
      toAdd[oneParamName] = String.fromCharCode(160);
      array.push(toAdd);
    }
    return array;
  }
}

